import { jsx as u, jsxs as v } from "react/jsx-runtime";
import { createContext as T, forwardRef as I, useRef as k, useState as N, useMemo as y, useContext as M, useId as K } from "react";
import { bindForwardedRef as w } from "@givebutter/react-util";
import { ANY_COUNTRY_PHONE_MASK as O, DATE_MASK as D, VERIFICATION_CODE_MASK as P, EIN_MASK as j, WHOLE_NUMBER_MASK as z, DECIMAL_MASK as H } from "@givebutter/util";
import { useMaskito as L } from "@maskito/react";
import { SingleSelectTrigger as U } from "../single-select/SingleSelect.js";
import { twMerge as x } from "tailwind-merge";
const S = T({
  isError: !1,
  disabled: !1,
  isFocused: !1,
  inputRef: null,
  /* v8 ignore next 2 */
  setIsFocused: () => {
  },
  setInputRef: () => {
  }
}), R = I((o, a) => {
  const {
    className: i,
    children: l,
    mask: e,
    isError: s = !1,
    disabled: p = !1,
    size: c = "md",
    onMouseDown: g,
    onFocus: d,
    onClick: m,
    ...f
  } = o, b = k(null), [t, C] = N(!1), [n, E] = N(null), _ = y(
    () => ({
      mask: e,
      disabled: p,
      isError: s,
      isFocused: t,
      inputRef: n,
      setInputRef: E,
      setIsFocused: C
    }),
    [p, n, s, t, e]
  );
  return /* @__PURE__ */ u(S.Provider, { value: _, children: /* @__PURE__ */ u(
    "div",
    {
      ref: (r) => {
        b.current = r, w(a, r);
      },
      onMouseDown: (r) => {
        r.target !== n && r.preventDefault(), g == null || g(r);
      },
      onClick: (r) => {
        r.target !== n && (n == null || n.focus()), m == null || m(r);
      },
      onFocus: (r) => {
        r.target === n && (n == null || n.focus()), d == null || d(r);
      },
      className: x(
        "w-inherit flex h-fit min-h-6 cursor-text items-center gap-2 rounded-lg bg-white px-3 text-gray-900 ring-1 ring-inset ring-gray-300",
        //
        c === "sm" && "py-1",
        c === "md" && "py-2",
        c === "lg" && "py-2.5",
        //
        p && "cursor-not-allowed bg-gray-50 text-gray-300",
        //
        (s || t) && "ring-2",
        s && "ring-red-500",
        //
        t && "ring-blue-500",
        //
        i
      ),
      ...f,
      children: l
    }
  ) });
});
R.displayName = "InputRoot";
const F = I((o, a) => {
  const { className: i, disabled: l, onFocus: e, onBlur: s, ...p } = o, {
    setIsFocused: c,
    disabled: g,
    mask: d = "none",
    setInputRef: m
  } = M(S), f = y(() => Y(d), [d]), b = L({ options: f });
  return /* @__PURE__ */ u(
    "input",
    {
      ref: (t) => {
        b(t), w(a, t), m(t);
      },
      disabled: l || g,
      className: x(
        //
        "h-full min-h-6 max-w-full flex-grow appearance-none border-none bg-transparent outline-none",
        //
        "disabled:cursor-not-allowed disabled:placeholder:text-gray-200",
        //
        "placeholder:text-gray-400",
        i
      ),
      onFocus: (t) => {
        c(!0), e == null || e(t);
      },
      onBlur: (t) => {
        c(!1), s == null || s(t);
      },
      ...p
    }
  );
});
F.displayName = "InputForm";
const h = I(
  (o, a) => {
    const { children: i, ...l } = o;
    return (
      /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
      /* @__PURE__ */ u(
        "div",
        {
          ref: a,
          onMouseDown: (e) => e.stopPropagation(),
          onClick: (e) => e.stopPropagation(),
          ...l,
          children: i
        }
      )
    );
  }
);
h.displayName = "InputInteractable";
const A = (o) => {
  const { className: a, disabled: i, ...l } = o, { disabled: e } = M(S), s = K();
  return /* @__PURE__ */ v(h, { children: [
    /* @__PURE__ */ u("label", { htmlFor: s, className: "sr-only", children: "Select value for input" }),
    /* @__PURE__ */ u(
      U,
      {
        id: s,
        disabled: i || e,
        className: x(
          "size-auto bg-transparent p-0 px-2 py-1 ring-0 focus:ring-2 disabled:!text-gray-300 [&>*]:leading-none",
          a
        ),
        ...l
      }
    )
  ] });
};
A.displayName = "InputSingleSelectTrigger";
const Y = (o) => {
  switch (o) {
    case "decimal":
      return H;
    case "whole-number":
      return z;
    case "ein":
      return j;
    case "verification-code":
      return P;
    case "date":
      return D;
    case "phone":
      return O;
    case "none":
      return;
  }
}, Q = R, X = F, Z = h, ee = A;
export {
  X as Form,
  S as InputContext,
  F as InputForm,
  h as InputInteractable,
  R as InputRoot,
  A as InputSingleSelectTrigger,
  Z as Interactable,
  Q as Root,
  ee as SingleSelectTrigger
};
